import Phaser from 'phaser';
import { createGhostVisual } from '../game/ghostVisuals';

export class LobbyScene extends Phaser.Scene {
  constructor() { super('lobby'); }

  create(): void {
    document.body.classList.add('lobby-active');
    document.body.classList.remove('gameplay-active');
    window.dispatchEvent(new Event('phi-lobby-ready'));
    this.events.once(Phaser.Scenes.Events.SHUTDOWN, () => document.body.classList.remove('lobby-active'));
    this.drawLobby();
    const resize = () => this.scene.restart();
    this.scale.on(Phaser.Scale.Events.RESIZE, resize);
    this.events.once(Phaser.Scenes.Events.SHUTDOWN, () => this.scale.off(Phaser.Scale.Events.RESIZE, resize));
  }

  private drawLobby(): void {
    const { width, height } = this.scale;
    const font = 'Noto Sans Thai, system-ui';
    const groundY = height * 0.86;

    this.cameras.main.setBackgroundColor('#080a0d');

    const sky = this.add.graphics().setDepth(-40);
    sky.fillStyle(0x080a0d).fillRect(0, 0, width, height);
    sky.fillStyle(0x121a22, 0.82).fillRect(0, height * 0.12, width, height * 0.72);

    this.add.image(width * 0.5, 0, 'env-village-midground').setOrigin(.5, 0)
      .setDisplaySize(width, height * .80)
      .setAlpha(0.85)
      .setDepth(-5);
    this.add.image(width * .5, height * .80, 'env-village-terrain').setOrigin(.5, 0)
      .setDisplaySize(width, height * .20)
      .setAlpha(.85)
      .setDepth(-4);

    const moon = Phaser.Math.Clamp(height * 0.14, 52, 112);
    this.add.circle(width * .72, height * .16, moon * .32, 0xc1ccbd, .7).setDepth(-6);

    const fog = this.add.graphics().setDepth(-2);
    fog.fillStyle(0xaebbb8, 0.04).fillEllipse(width * 0.34, height * 0.62, width * 0.78, height * 0.18);
    fog.fillStyle(0xaebbb8, 0.025).fillEllipse(width * 0.78, height * 0.68, width * 0.62, height * 0.14);

    const world = this.add.graphics().setDepth(-1);
    world.fillStyle(0x0a0e0c, 0.86).fillRect(0, groundY, width, height - groundY);
    world.fillStyle(0x40553c, 0.42).fillRect(0, groundY, width, 3);

    if (width > 700) {
      const leftGhost = createGhostVisual(this, 'krasue');
      leftGhost.container.setPosition(width * 0.12, groundY - 46).setScale(0.48).setAlpha(0.18);
      const rightGhost = createGhostVisual(this, 'tanee');
      rightGhost.container.setPosition(width * 0.90, groundY - 32).setScale(0.55).setAlpha(0.16);
    }

    if (height > 560) this.add.text(width / 2, height * 0.14, 'PHI SIAM', {
      fontFamily: font,
      fontSize: `${Phaser.Math.Clamp(width * 0.05, 36, 72)}px`,
      fontStyle: 'bold',
      color: '#ead9b3',
      stroke: '#0a0807',
      strokeThickness: 8,
      shadow: { offsetX: 0, offsetY: 5, color: '#000000', blur: 12, fill: true },
    }).setOrigin(0.5);

    if (height > 560) this.add.text(width / 2, height * 0.14 + Phaser.Math.Clamp(height * 0.075, 42, 62), 'ONLINE • ผีสยาม', {
      fontFamily: font,
      fontSize: `${Phaser.Math.Clamp(width * 0.017, 12, 21)}px`,
      fontStyle: 'bold',
      color: '#b78b53',
      letterSpacing: 3,
    }).setOrigin(0.5);

    this.add.text(width / 2, height * 0.92, 'เลือกตัวละคร • พบเพื่อน • ล่าผีในโลกเดียวกัน', {
      fontFamily: font,
      fontSize: `${Phaser.Math.Clamp(width * 0.009, 8, 12)}px`,
      color: '#899b94',
    }).setOrigin(0.5);
  }
}
